module.exports = __webpack_public_path__ + "img/i_wine.0586aab8.png";